import openkit from "openkit";

export const getVillagePanorama = async (villageSlug) => {
  try {
    const resp = await openkit.data.find("configs", { id: "panoramas" });
    const villagePanorama = resp[0].data.find((a) => a.village === villageSlug);
    return villagePanorama;
  } catch (error) {
    console.log("error :>> ", error);
  }
};
